import * as React from 'react'

export type CardProps = {
	icon?: React.ReactNode
	title: string
	description: string
	className?: string
}

export const TechCard: React.FC<CardProps> = ({
	icon,
	title,
	description,
	className,
}) => {
	return (
		<div
			className={`flex flex-col gap-3 rounded-2xl border border-gray-200 bg-white p-6 shadow-xs ${className}`}
		>
			<div className="flex h-10 w-10 items-center justify-center rounded-full bg-sky-500 text-white">
				{icon}
			</div>
			<h3 className="text-2xl font-medium text-blue-900">{title}</h3>
			<p className="leading-relaxed text-neutral-800">{description}</p>
		</div>
	)
}
